module.exports = __webpack_public_path__ + "img/skills_graphic_ES_CA.4429a44f.png";